import React, { useEffect, useState } from "react";
import { getApi } from "../../../../services/api/globalApi";
import { PiImageSquareFill, PiXFill } from "react-icons/pi";

const { forwardRef, useRef, useImperativeHandle } = React;

const UserModal = forwardRef(({ handleUser }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const [userData, setUserData] = useState([]);

  const getUsers = async (params) => {
    const path = "admin/users";
    try {
      const response = await getApi({ path, params: { ...params } });
      console.log(response.data.result);
      setUserData(response?.data.result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const selectProduct = (item) => {
    console.log(item);
    handleUser(item);
    setShowModal(false)
  };

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUsers(allFilter);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-50  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[320px] md:w-[768px] py-4 max-h-[380px] dark:bg-gray-900 bg-white mt-4 shadow-md z-[80] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] md:mr-[-384px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2 dark:text-white">
          <h4>آخرین کاربر ها</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>

        <div className="w-11/12 mx-auto mt-4">
          <div class="max-w-md mx-auto">
            <label
              for="default-search"
              class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                <svg
                  class="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                onChange={(e) =>
                  filterDataHandler({ page: 1, searchText: e.target.value })
                }
                type="search"
                className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="جست و جو کاربر ..."
                required
              />
            </div>
          </div>
        </div>


        {userData?.length > 0 ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6 h-[200px] overflow-y-scroll">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    نام
                  </th>
                  <th scope="col" className="px-6 py-3">
                    موبایل
                  </th>
                  <th scope="col" className="px-6 py-3">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {userData.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.name}
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.mobile}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => selectProduct(item)}
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          افزودن
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 py-4 w-full mt-6 text-gray-700 dark:text-white">
            کاربر یافت نشد
            <PiImageSquareFill size={50} />
          </div>
        )}
      </div>
    </>
  );
});
export default UserModal;
